// Dates limites de commande par maison (offres à date butoir, ex. Beaujolais Nouveau)
export const ORDER_DEADLINES = {
  "Beaujolais Nouveau": { date: "2026-11-03T23:59:59+01:00", label: "Commande avant le 3 novembre" },
};

export function getDeadline(producer) {
  const d = ORDER_DEADLINES[producer];
  if (!d) return null;
  const ts = new Date(d.date).getTime();
  return ts > Date.now() ? { ...d, ts } : null;
}
